import { useCallback } from 'react';
import { Article } from '../models/ArticleResult';
import { gql } from '@apollo/client';
import { graphql } from '@xolv-mybrightlink/common';

const FETCH_BOOKMARKED_ARTICLE_SLUGS = gql`
  query bookmarkedSlugs($slugs: [String]) {
    bookmarkedSlugs(type: "article", slugs: $slugs)
  }
`;

export const useFetchBookmarkedArticles = () => {
  return useCallback(async (articles: Article[]) => {
    const slugs = articles.map((article) => article.slug);
    if (slugs.length === 0) {
      return [];
    }
    const response = await graphql.query<{ bookmarkedSlugs: string[] }>({
      query: FETCH_BOOKMARKED_ARTICLE_SLUGS,
      variables: { slugs },
      fetchPolicy: 'no-cache',
    });
    const bookmarkedSlugs = response.data.bookmarkedSlugs;
    return articles.map((article) => {
      const isSaved = bookmarkedSlugs.some((slug) => slug === article.slug);
      return { ...article, isSaved };
    });
  }, []);
};
